import { IconWrapper } from '../runtime';
export default IconWrapper('star', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M7.72828 1.38069C7.83612 1.15022 8.16388 1.15022 8.27172 1.38069L10.2249 5.55485L14.8464 6.095C15.1019 6.12486 15.2038 6.44138 15.0137 6.61468L11.6 9.72658L12.5073 14.2277C12.5578 14.4782 12.292 14.6731 12.0683 14.5496L8 12.3049L3.93172 14.5496C3.70799 14.6731 3.44221 14.4782 3.4927 14.2277L4.4 9.72658L0.986285 6.61468C0.796177 6.44138 0.898059 6.12486 1.15356 6.095L5.77508 5.55485L7.72828 1.38069Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});